import {IMPERIAL, METRIC} from 'Utils/constants';
import lodashRound from 'lodash/round';

export const getLengthLabel = (unitOfMeasure, isShort = false) => {
    if (unitOfMeasure === METRIC) {
        return 'km';
    }
    return isShort ? 'mi' : 'mile';
};

export const convertToMetres = (unitOfMeasure, value) => {
    if (unitOfMeasure === METRIC) {
        return value * 1000;
    }
    return value * 1.60934 * 1000;
};

export const displayDistanceFromMetres = (
    unitOfMeasure,
    distanceInMetres,
    longUnitNames = false
) => {
    // in case of myLocation result we do not show distance
    if (!distanceInMetres) {
        return '';
    }
    if (unitOfMeasure === IMPERIAL) {
        const distancesInMiles = distanceInMetres * 0.000621371;
        return `${lodashRound(distancesInMiles, 2)} miles`;
    }

    if (distanceInMetres < 500) {
        return `${lodashRound(distanceInMetres, 0)} ${longUnitNames ? 'meters' : 'm'}`;
    }
    return `${lodashRound(distanceInMetres / 1000, 2)} km`;
};
